<script setup>
import { computed, getCurrentInstance } from 'vue';
import ToggleSwitch from 'dashboard/components-next/switch/Switch.vue';

const props = defineProps({
  id: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  label: { type: String, default: '' },
  helper: { type: String, default: '' },
});

const modelValue = defineModel({
  type: Boolean,
  default: false,
});

const { uid } = getCurrentInstance();
const toggleId = computed(() => props.id || `agent-toggle-${uid}`);
const labelId = computed(() => `${toggleId.value}-label`);
const helperId = computed(() => `${toggleId.value}-helper`);

const toggleFromLabel = () => {
  if (props.disabled) return;
  modelValue.value = !modelValue.value;
};
</script>

<template>
  <div
    class="flex w-full items-start justify-between gap-3 py-2"
    :class="{ 'cursor-not-allowed opacity-50': disabled }"
  >
    <label
      :for="toggleId"
      class="flex min-w-0 flex-1 cursor-pointer flex-col"
      :class="{ '!cursor-not-allowed': disabled }"
      @click.prevent="toggleFromLabel"
    >
      <span
        v-if="label"
        :id="labelId"
        class="text-sm font-medium text-n-slate-12"
      >
        {{ label }}
      </span>
      <span
        v-if="helper"
        :id="helperId"
        class="mt-1 text-xs leading-relaxed text-n-slate-11"
      >
        {{ helper }}
      </span>
    </label>

    <ToggleSwitch
      :id="toggleId"
      v-model="modelValue"
      :disabled="disabled"
      :aria-labelledby="label ? labelId : helper ? helperId : undefined"
      :aria-describedby="label && helper ? helperId : undefined"
      class="mt-0.5"
    />
  </div>
</template>
